import script from "./DocsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./DocsPage.vue?vue&type=script&setup=true&lang=js"

import "./DocsPage.vue?vue&type=style&index=0&id=e445ef48&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e445ef48"]])

export default __exports__